import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { JobFiltersEventHandler } from '@ClientBase/Generic/JobFiltersEventHandler'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import { BurgerMenuEventHandler } from '@ClientBase/Generic/BurgerMenuEventHandler'
import { CreateCarousels } from './CarouselsNew'
import { AddAccessibleNavigationHandlers } from '@ClientBase/Generic/NavKeyboardControls'
import * as VideoSnippet from './VideoSnippet'
import * as DomMainipulations from './DomMainipulations'
import * as Navigation from './Navigation'
import * as BrowserJobsOVerlay from './BrowseJobsOverlay'
import * as Filters from './Filters'
import * as StickyApply from './StickyApply'
import * as JobTile from './JobTile'
import * as Modal from './Modal'
import * as PostTile from './PostTile'
import * as ListWidget from './ListWidget'
import * as SocialProfile from './SocialProfileWidget'
import * as Footer from './Footer'
import * as DialogVideos from './DialogVideos'
import * as CarouselHeading from './CarouselHeading'
import * as JobFilters from './JobFilters'
import * as ListWidgetNav from './ListWidgetNav'
import * as CtaBanner from './CtaBanner'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import * as MapWidget from './MapWidget'
import * as Workflow from "@ClientBase/Generic/WorkFlowStyling"
import * as JobDetails from './JobDetails'

//snippets
import {SnippetSpacer} from "./Spacer/Spacer";
import {SnippetImageContent} from "./ImageContent/ImageContent";
import {SnippetImageGallery} from "./ImageGallery/ImageGallery";
import SnippetVideo from './Video/Video';
import {SnippetContentColumn} from './ContentColumn/ContentColumn'
import {SnippetIconsTextHover} from './IconsTextHover/IconsTextHover'
import {SnippetStatistics} from './Statistics/Statistics';
import {SnippetAccordion} from './Accordion/Accordion';
import { SnippetAccordionAlternate } from './AccordionAlternate/AccordionAlternate';
import {SnippetQuotes} from './QuotesPostsDetails/QuotesPostsDetails'
import {SnippetButtons} from './Buttons/Buttons';
import {SnippetInstagram} from './Instagram/Instagram';

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    "SnippetSpacer": SnippetSpacer,
    "SnippetImageContent": SnippetImageContent,
    "SnippetImageGallery": SnippetImageGallery,
    "SnippetVideo": SnippetVideo,
    "SnippetContentColumn": SnippetContentColumn,
    "SnippetIconsTextHover": SnippetIconsTextHover,
    "SnippetStatistics": SnippetStatistics,
    "SnippetAccordion": SnippetAccordion,
    "SnippetAccordionAlternate": SnippetAccordionAlternate,
    "SnippetHeading": SnippetHeading,
    "SnippetContent" : SnippetContent,
    "SnippetButtons": SnippetButtons,
    "SnippetInstagram": SnippetInstagram
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.navigationFunctions()
        JobFiltersEventHandler.useAttraxTsHandlers($)
        PostFiltersEventHandler.useAttraxTShandler($)
        BurgerMenuEventHandler.handleClickEvents($)
        VideoSnippet.VideoClickHandler()
        DomMainipulations.homePageScroll($)
        DomMainipulations.moveLinkedInButton($)
        DomMainipulations.moveFilterButton($)
        DomMainipulations.injectJsResource($)
        DomMainipulations.repositionBioModal($)
        DomMainipulations.createStickyApplyHeading($)
        AddAccessibleNavigationHandlers()
        DomMainipulations.moveSendCvModal($)
        DomMainipulations.removeFooterAutocomplete($)
        DomMainipulations.displayNoSavedJobsMessage($)
        DomMainipulations.showExpiredVacancyBanner($)
        DomMainipulations.addClearbtn()
        DomMainipulations.removeNonBreakingSpaceFromJobDetails()
        DomMainipulations.showAuthorDetailsIfAuthor()
        CreateCarousels()
        Filters.scrollHandler($)
        StickyApply.showStickyApply()
        JobTile.addLogo()
        JobTile.logoReplacer()
        JobTile.brandClassAssignment()
        JobTile.setActive()
        Modal.closeModalOnBgClick()
        PostTile.makePostTileClickable()
        ListWidget.checkIfJobTilesHaveProfile()
        ListWidget.moveReadMoreButtonLatestStories()
        SocialProfile.displayRecruiterIfAvailable()
        BrowserJobsOVerlay.BrowseJobsOverlay()
        Footer.FooterHandlers()
        DialogVideos.initialise();
        CarouselHeading.createCarouselHeader();
        JobFilters.addFilterTextHeadingJobResults();  
        JobFilters.moveKeyword()
        ListWidgetNav.ListWidgetNav()
        CtaBanner.zoomIn();
        MapWidget.SetMapInteractable();
        JobDetails.removenbspfromjobdestails();
        Workflow.HandleIntegratedWorkflows();
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    }
})
